import { useEffect, useState } from "react";
import { api } from "@/api";
import { History, FileText } from "lucide-react";
import ReportCard from "@/components/ReportCard";

export default function MyHistoryPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/reports/mine", { params: { limit: 90 } });
      setItems(data.items || []);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <>
      <div className="page-heading compact-heading">
        <div>
          <p className="eyebrow">Geçmiş</p>
          <h1>Rapor geçmişim</h1>
          <p className="subheading">Son 90 gündeki tüm raporlarınız.</p>
        </div>
      </div>

      {loading ? (
        <div className="loading-block">Yükleniyor…</div>
      ) : items.length === 0 ? (
        <div className="empty-state">
          <History size={28}/>
          <h3>Henüz rapor yok</h3>
          <p>Günlük Rapor sayfasından ilk raporunuzu yazabilirsiniz.</p>
        </div>
      ) : (
        <div className="reports-grid" data-testid="my-history-list">
          {items.map((r) => <ReportCard key={r.id} report={r} onChanged={load} />)}
        </div>
      )}
    </>
  );
}
